import { seoModuleInfo } from "@/api/index";

const seo = {
  namespaced: true,
  state: {
    seoData: null,
    defaultSeoData: null, // 新增：存储默认SEO数据
    keywords: null,
    describe: null,
  },
  getters: {
    getSeoData(state) {
      return state.seoData;
    },
    getDefaultSeoData(state) {
      return state.defaultSeoData;
    },
  },
  mutations: {
    SET_SEO_DATA(state, data) {
      state.seoData = data;
    },
    // 新增：设置默认SEO数据
    SET_DEFAULT_SEO_DATA(state, data) {
      state.defaultSeoData = data;
      // 同时保存到localStorage
      localStorage.setItem("defaultSeo", JSON.stringify(data));
    },
    // 新增：恢复默认SEO
    RESTORE_DEFAULT_SEO(state) {
      if (state.defaultSeoData) {
        state.seoData = { ...state.defaultSeoData };
        console.log("已恢复默认SEO:", state.seoData);
      }
    },
    SET_SEO_KEY(state, data) {
      state.keywords = data;
      localStorage.setItem("seokey", data);
    },
  },
  actions: {
    async fetchSeoData({ commit, state }) {
      // 如果已有默认数据，直接返回
      if (state.defaultSeoData) {
        return;
      }

      try {
        const response = await seoModuleInfo({
          moduleCode: "SEO_SETTING",
          language: localStorage.getItem("lang"),
        });
        if (response.code === 200) {
          // console.log("✅ 接口返回 SEO 数据:", response.data);
          commit("SET_SEO_DATA", response.data);
          commit("SET_DEFAULT_SEO_DATA", response.data); // 保存为默认数据
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);

        // 尝试从localStorage恢复默认数据
        const savedDefault = localStorage.getItem("defaultSeo");
        if (savedDefault) {
          try {
            const defaultData = JSON.parse(savedDefault);
            commit("SET_DEFAULT_SEO_DATA", defaultData);
            commit("RESTORE_DEFAULT_SEO");
          } catch (e) {
            console.error("解析默认SEO数据失败:", e);
          }
        }
      }
    },
  },
};

export default seo;
